export default __webpack_public_path__ + "static/media/eight.9f79eba3.png";